import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { AbstractControl, UntypedFormGroup } from "@angular/forms";
import { throwError } from "rxjs";

export class Common {
  static sortByProperty<T>(propertyName: string, array: T[]): any {
    return array.sort((current, next) => {
      if (current[propertyName] > next[propertyName]) {
        return 1;
      } else if (current[propertyName] < next[propertyName]) {
        return -1;
      }
      return 0;
    });
  }
  static downloadFile(fileinfo: FileInfo): void {
    const arrayBuffer = this.base64ToArrayBuffer(fileinfo.byteStream);
    const blob = new Blob([arrayBuffer], { type: fileinfo.blobType });
    const link = document.createElement("a");
    link.style.display = 'none';
    const fileURL = window.URL.createObjectURL(blob);
    link.href = fileURL;
    link.download = `${fileinfo.fileName}`;
    link.click();
    link.remove();
  }
  static base64ToArrayBuffer(base64: string) {
    const binaryString = window.atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
  }

  static convertToCamelCase(str) {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
  }

  static toLowerKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }

  static openBlobInNewTab(blob) {
    const fileURL = window.URL.createObjectURL(blob);
    window.open(fileURL, '_blank');
  }
  static dataUrlToBlob(dataurl): Blob {
    const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]);
    let n = bstr.length;
    const u8Arr = new Uint8Array(n);
    while (n--) {
      u8Arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8Arr], { type: mime });
  }
  static setPhoneNumber(value): string {
    if (!value) {
      return value;
    }
    value = value.replaceAll('-', '');
    return value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 10);
  }
  static ValidateDay(day: number, month: number, year: number): boolean {
    const longMonth = [1, 3, 5, 7, 8, 10, 12];
    const short = []
    if (longMonth.indexOf(month) != -1) {
      return day > 31;
    }
    else if (month == 2) {
      if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
        return day > 29;
      }
      else {
        return day > 28;
      }
    }
    else {
      return day > 30;
    }
  }
  static checkValidDate(currentVal): boolean {
    const str = currentVal.split('/');
    let yyyy = Number(str[2]);
    let dd = Number(str[1]);
    let mm = Number(str[0]);
    if (dd === 0 || mm === 0 || yyyy === 0) {
      return true;
    }
    let dt = new Date(yyyy, (mm - 1), dd);
    let ctryy = dt.getFullYear();
    let ctrdd = dt.getDate();
    let ctrmm = dt.getMonth() + 1;
    return (dd !== ctrdd || mm !== ctrmm || yyyy !== ctryy);
  }
  static allowDigits($event) {
    const val = $event.key;
    let patern = /[0-9]/g;
    if (val.match(patern) == null || val.match(patern)[0] != val) {
      $event.preventDefault();
    }
  }
  static checkdateFormat(currentVal): boolean {
    const str = currentVal.split('/');
    if (str.length == 3) {
      if ((str[0].length < 2 || str[1].length < 2 || str[2].length < 4))
        return true;
    }
    let yyyy = Number(str[2]);
    let dd = Number(str[1]);
    let mm = Number(str[0]);
    return (Common.ValidateDay(dd, mm, yyyy) || mm > 12 || yyyy.toString().length < 4)
  }
  static dateofBirthValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const providedYear = new Date(control.value).getFullYear();
    if (providedYear && providedYear.toString().length === 3) {
      return { 'format': true };
    }
    return null;
  }
  static handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    if (error)
      return throwError(() => error.error);
    else
      return throwError(() => 'Something bad happened; please try again later.');
  }
  static htmlToPlainText(htmlContent: any): string {
    let elem = document.createElement('div');
    elem.style.display = 'none';
    elem.innerHTML = htmlContent;
    const plainText = elem.innerText || elem.textContent || '';
    elem.remove();
    return plainText;
  }
  static removeDuplicatesObjectFromJsonArrayByProp(array, key) {
    var check = new Set();
    return array?.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
  }
  static selectAll($event: any, form: UntypedFormGroup, control: string, value: any = ''): void {
    if ($event.isUserInput)
      form.controls[control].setValue(value);
  }
  static changeSelection($event, form: UntypedFormGroup, controlName: string, value: any = ''): void {
    let val = $event.value.filter(f => f);
    val = val?.length ? val : value;
    form.controls[controlName].setValue(val);
  }
  static setDefaultValueForDropdownList(formControl: AbstractControl, array: any[], prop: string) {
    if (array?.length === 1) {
      formControl.setValue([array[0][prop]]);
      formControl.disable();
    }
  }

  static setDefaultValueForDropdown(formControl: AbstractControl, array: any[], prop: string) {
    if (array?.length === 1) {
      formControl.setValue(array[0][prop]);
      formControl.disable();
    }
  }

  static minAndFormatDateValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const currentYear = new Date().getFullYear();
    const providedYear = new Date(control.value).getFullYear();
    if (providedYear && providedYear.toString().length === 3) {
      return { 'format': true };
    }
    else if (control.value && new Date(control.value) < new Date(1900, 0, 1)) {
      return { 'min_Date': true };
    }
    return null;
  }
  static convertTimeStampToseconds(timeStamp: number) {
    let diff = new Date(timeStamp * 1000).getTime() - new Date().getTime();
    return diff / 1000;
  }
  static getDateDiffDays(startDate, endDate): number {
    if (!startDate && !startDate)
      return 0;
    return Math.ceil(Math.abs(startDate - endDate) / (1000 * 60 * 60 * 24));
  }
}
export interface FileInfo {
  byteStream: any,
  blobType: string,
  fileName: string
}
